export class SongDetails {
    constructor() {
    }

    date: string;
    name: string;
    numberOfPlayed: number;
    songId: string;
    totalTime: number;
    userId: string;
    moodId: string;
    moodName: string;
}
